import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-redsys-loading',
  templateUrl: './redsys-loading.html',
  styleUrls: ['./redsys-loading.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedsysLoadingComponent {
  constructor() {}
}
